<template>
  <div class="report">
    <Header></Header>
    <router-view />
  </div>
</template>

<script>
import Header from '../components/navbar.vue'
export default {
  name: "Report",
  components: {
    Header
  }
}
</script>
<style lang="less" scoped>
.report {
  height: 100%;
}
</style>
